import { render, staticRenderFns } from "./EnterMarksSheet.vue?vue&type=template&id=e80b2326&scoped=true"
import script from "./EnterMarksSheet.vue?vue&type=script&lang=js"
export * from "./EnterMarksSheet.vue?vue&type=script&lang=js"
import style0 from "./EnterMarksSheet.vue?vue&type=style&index=0&id=e80b2326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80b2326",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VContainer,VDataTable})
